// extracted by mini-css-extract-plugin
export default {"wrap":"Yt-z","fullWidth":"Zt-z","items":"_t-z","featureCss":"au-z","disabled":"bu-z","imgCss":"cu-z"};